export default function(message = '', type = 'success'){
    const el = document.createElement('div');
    el.classList.add('c-popup-message');
    el.classList.add('c-popup-message--' + type);
    el.innerHTML = `            <div class="c-popup-message__content">
                <button type="button" class="c-popup-message__close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <p>${message}</p>
            </div>
            `;

    el.querySelector('.c-popup-message__close').addEventListener('click',()=>{
        el.remove();
    });

    document.body.append(el);
}
